import { useParams, useNavigate } from 'react-router-dom';
import SpreadsheetView from '../components/spreadsheet/SpreadsheetView';

export default function SpreadsheetPage() {
  const { viewId } = useParams();
  const navigate = useNavigate();

  return (
    <div className="h-screen flex flex-col" style={{ height: '100vh' }}>
      <SpreadsheetView
        viewId={viewId}
        onClose={() => navigate('/analytics')}
        onSelectView={(newViewId) => navigate(`/analytics/views/${encodeURIComponent(newViewId)}/spreadsheet`)}
      />
    </div>
  );
}
